<template>
<div>
  <v-row>
    <!-- <v-col cols="12" md="6">
      <h1>經費預借申請</h1>
    </v-col> -->
    <v-col cols="12" md="12" class="text-right">
      <div class="d-inline-block" v-if="tbtca61Vo.deptNo==userDataCookie.depNo">
        <v-btn color="primary" variant="tonal" class="mr-2" @click="save" 
          v-if="Object.keys(viewParams.actionBtn).length === 0 || tbtca61Vo.status === 'Draft' ">
          儲存
        </v-btn>
        <v-btn color="success" variant="tonal" class="mr-2" @click="submit"
        v-if="isAssociationContact(userDataCookie, submissionAsContact)&&((Object.keys(viewParams.actionBtn).length> 0 && viewParams.actionBtn.action_start) ||(tbtca61Vo.status === 'Draft'&&tbtca61Vo.borrowApplyNo))">
          送出
        </v-btn>
        <v-btn color="error" variant="tonal" class="mr-2" @click="deleteForm"
        v-if="tbtca61Vo.createEmpNo==userDataCookie.userno&&((tbtca61Vo.status === 'Draft'&&tbtca61Vo.borrowApplyNo) || (Object.keys(viewParams.actionBtn).length> 0 && viewParams.actionBtn.action_cancel))">
          刪除
        </v-btn>
      </div>
      <v-btn color="error" variant="tonal" class="mr-2" @click="withdraw"
      v-if="Object.keys(viewParams.actionBtn).length> 0 && viewParams.actionBtn.action_revoke">
        收回
      </v-btn>
      <v-btn color="primary" variant="tonal" class="mr-2" @click="passed"
      v-if="Object.keys(viewParams.actionBtn).length> 0 && viewParams.actionBtn.action_approve">
        通過
      </v-btn>
      <v-btn color="error" variant="tonal" class="mr-2" @click="reject"
      v-if="Object.keys(viewParams.actionBtn).length> 0 && viewParams.actionBtn.action_reject">
        駁回
      </v-btn>
    </v-col>
  </v-row>
  <v-row>
    <v-col cols="8" >
      <v-card>
        <v-form ref="formRef">
          <v-card-item>
            <v-row>
              <v-col cols="12">
                <div class="text-subtitle-2">所屬經費需求項目<Required/></div>
                <v-select
                  item-title="projectTitle"
                  item-value="projectId"
                  v-model="tbtca61Vo.applyNo"
                  :items="viewParams.applyNoSelect" :rules="[rules.required]"></v-select>
              </v-col>
              <v-col cols="12" md="12">
                <div class="text-subtitle-2">標題<Required/></div>
                <v-text-field v-model="tbtca61Vo.title" :rules="[rules.required]"></v-text-field>
              </v-col>
              <v-col cols="12" md="12">
                <div class="text-subtitle-2">金額<Required/></div>
                <AmountTextField v-model="tbtca61Vo.amount" :rules="[rules.integerRule]" />
              </v-col>
              <!-- <v-col cols="12" md="12">
                <div class="text-subtitle-2">公文號</div>
                <v-text-field v-model="tbtca61Vo.docNo" :rules="[rules.required]"></v-text-field>
              </v-col> -->
              <v-col cols="12" md="12">
                <div class="text-subtitle-2">預借原因<Required/></div>
                <v-textarea v-model="tbtca61Vo.reason" rows="2" :rules="[rules.required]"></v-textarea>
              </v-col>
            </v-row>
          </v-card-item>
        </v-form>
      </v-card>
    </v-col>
    <v-col cols="4" >
      <v-card width="" height="100%">
        <v-card-text class="pa-0">
          <!-- <v-list class="pa-0"> -->
            <v-row class="ma-0">
              <UserInfo
              :isShow="[true,true,true,true,false,false]"
              :application-number="tbtca61Vo.borrowApplyNo"
              :status="tbtca61Vo.status"
              :user-info="tbtca61Vo.applyEmpNo"
              documentNumber=""
              issueDate=""
              status-component="ExpenseBorrow"
              />
            </v-row>
          <!-- </v-list> -->
        </v-card-text>
      </v-card>
  </v-col>
</v-row>
<v-row>
  <v-col cols="12"  v-if="viewParams.actionBtn && viewParams.actionBtn.action_approve">
    <v-card>
      <v-card-item>
        <div class="text-subtitle-1 mb-2">審核意見</div>
        <v-textarea placeholder="輸入審核意見" required v-model="tbtca62Vo.reviewComment"  rows="2"></v-textarea>
      </v-card-item>
    </v-card>
  </v-col>
  <!-- <div class="text-subtitle-1 mb-2">簽核歷程</div> -->
  <v-col v-if="tbtca61Vo.status!=='Draft'">
    <SignOffHistory
      :form-id="tbtca61Vo.formId"
      :refresh="tbtca61Vo.refreshForm"
    />
  </v-col>
<!--  <v-col cols="12" v-if=" tbtca62Vos.length > 0">-->
<!--    <v-card>-->
<!--      <v-card-item>-->
<!--        <div class="text-subtitle-1 mb-2">簽核歷程</div>-->
<!--          <v-data-table :items="tbtca62Vos" :headers="tbtca62VosHeaders" fixed-header height="200px" items-per-page="-1">-->
<!--            <template v-slot:item.status="{ item }">-->
<!--              <Status -->
<!--                :status="item.status"-->
<!--                :is-red="['Rejected']"-->
<!--                :is-green="['Submitted','FApproved','MApproved','Passed']"-->
<!--                :is-primary="['Draft','ReturnedForRevision']"-->
<!--                shared-table-id="ExpenseBorrow"-->
<!--                btn-class="x-large"-->
<!--                font-class="18px"-->
<!--              />-->
<!--            </template>-->
<!--            <template v-slot:item.createTime="{ item }">-->
<!--              <td v-if="item.createTime">{{ convertToROCDate(item.createTime) }}</td>-->
<!--            </template>-->
<!--          <template v-slot:bottom> </template>-->
<!--        </v-data-table>-->

<!--      </v-card-item>-->
<!--    </v-card>-->
<!--  </v-col>-->
</v-row>
</div>
</template>

<script setup lang="ts">
import Status from '../tnm/StatusComponenet.vue'
import UserInfo from '../tnm/UserInfoComponent.vue';
import {reactive} from "vue";
import SignOffHistory from '../../../components/SignOffHistoryComponent.vue'
import Required from '../../../components/required.vue'
import { isAssociationContact } from '@/utils/deUtil'

const route = useRoute()
const userDataCookie = useStorage('userData', {}).value

definePage({
  meta: {
      action: 'manage', //固定為 manage
      subject: 'EXPENSEBORROW', //系統代碼(系統授權設定中的系統代碼)
  },
});
const formRef = ref(null);

// 送出職稱設定
const submissionAsContact = useSessionStorage('SubmissionAsContact')

const rules = ref({
  required: (value: any) => !!value || '此欄位為必填',
  integerRule: value => {
    const n = Number(String(value ?? '').replace(/,/g, ''))
    // 檢查長度是否符合要求
    if (String(n).length >= 9) {
      return '長度請符合8位數以內';
    }
    
    // 檢查是否必填以及是否為整數
    return (!!value || value === 0) && Number.isInteger(n)
      ? true
      : '欄位為整數且必填';
  },
});

const validate =  async () => {
  const { valid } = await formRef.value.validate();
  return valid
}

const viewParams = reactive({
  applyNoSelect: [],
  actionBtn: {}
});

const tbtca61Vo = reactive({
  borrowApplyNo:'',
  applyNo:'',
  title:'',
  reason:'',
  amount:0,
  docNo:'',
  deptNo:userDataCookie.depNo,
  applyEmpNo: userDataCookie.userno,
  refreshForm:0,
  status: "Draft",
  createEmpNo:userDataCookie.userno,
});

const tbtca62Vo = reactive({
  borrowApplyNo:'',
  reviewComment:''
});

const userData = useStorage('userData', {}).value;

const tbtca62Vos = reactive([]);
const tbtca62VosHeaders = [
  { title: '日期', key: 'createTime', sortable: false },
  { title: '人員', key: 'serno', sortable: false },
  { title: '狀態', key: 'status', sortable: false },
  { title: '審核意見', key: 'reviewComment', sortable: false },
];

const getApplyNoSelect = async (deptNo) => {
  const apiUrl='/tca/expenserequestprojectlist/getProjectList'
  await $api(apiUrl, {
    method: 'POST',
    body:{
      deptNo:null,
      isGold:null,
    }
  }).then((resp) => {
    Object.assign(viewParams.applyNoSelect, resp.data); 
  })
};

onMounted(() => {
  if(route.query.borrowApplyNo){
    query(route.query.borrowApplyNo,true);
  } else {
    const deptNo=userData.depNo;
    getApplyNoSelect(deptNo);
  }
});

const query = async (queryBorrowApplyNo,msgShowFlag) => {
  const apiUrl='/tca/expenseborrow/get/' + queryBorrowApplyNo
  await $api(apiUrl, {
    method: 'GET'
  }).then((resp) => {

    if (resp.statusCode == 200) {
      Object.assign(tbtca61Vo, resp.data.tbtca61Vo); 
      Object.assign(tbtca62Vos, resp.data.tbtca62Vos); 
      getApplyNoSelect(tbtca61Vo.deptNo);
      if(tbtca61Vo.formId) {
        getFormActions(tbtca61Vo.formId);
        tbtca61Vo.refreshForm+=1;
      }
      if(msgShowFlag) {
        popSwal('success','查詢成功');
      }
    } else  {
       popSwal('error','查詢失敗,錯誤訊息'+resp.data);
    }

   
  })
};


const popSwal = (icon,title,text) => {
  if(icon=="success"){
    $swal({
      position: 'top-end',
      icon: icon,
      title: title,
      text: text,
      showConfirmButton: false,
      timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    });
  }else if (icon=="error"){
    $swal({
      position: 'top-end',
      icon: icon,
      title: title,
      text: text,
      showConfirmButton: false,
      // timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    });
  }else{
    $swal({
      position: 'top-end',
      icon: icon,
      title: title,
      text: text,
      showConfirmButton: false,
      // timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    });
  }
}


// 儲存
const save = async () => {
  if(!await validate()) {
    return ;
  }

  const apiUrl='/tca/expenseborrow/save'
  await $api(apiUrl, {
    method: 'POST',
    body: tbtca61Vo
  }).then((resp) => {
    if (resp.statusCode == 200) {
      Object.assign(tbtca61Vo, resp.data); 
      query(tbtca61Vo.borrowApplyNo,false);
      popSwal('success','儲存成功');
    } else  {
      popSwal('error','送出失敗,錯誤訊息'+resp.data);
    }
  })
};

// 刪除
const deleteForm= async () => {
  const formData = new FormData();
  formData.append('borrowApplyNo',tbtca61Vo.borrowApplyNo);
  const apiUrl='/tca/expenseborrow/delete'
  await $api(apiUrl, {
    method: 'POST',
    body: formData
  }).then((resp) => {
    if (resp.statusCode == 200) {
      popSwal('success','刪除成功');
      for (var member in tbtca61Vo) delete tbtca61Vo[member];
      tbtca62Vos.length = 0;
      viewParams.actionBtn = {};
      query(tbtca61Vo.borrowApplyNo,false);
    } else  {
      popSwal('error','刪除失敗,錯誤訊息'+resp.data);
    }
  })
};


//送出
const submit= async () => {
  const formData = new FormData();
  formData.append('borrowApplyNo',tbtca61Vo.borrowApplyNo);
  const apiUrl='/tca/expenseborrow/submit'
  await $api(apiUrl, {
    method: 'POST',
    body: formData
  }).then((resp) => {
    if (resp.statusCode == 200) {
      popSwal('success','送出成功');
      query(tbtca61Vo.borrowApplyNo,false);
    } else  {
      popSwal('error','送出失敗,錯誤訊息'+resp.data);
    }
  })
};

// 收回
const withdraw= async () => {
  const formData = new FormData();
  formData.append('borrowApplyNo',tbtca61Vo.borrowApplyNo);
  const apiUrl='/tca/expenseborrow/withdraw'
  await $api(apiUrl, {
    method: 'POST',
    body: formData
  }).then((resp) => {
    if (resp.statusCode == 200) {
      popSwal('success','收回成功');
      query(tbtca61Vo.borrowApplyNo,false);
    } else  {
      popSwal('error','收回失敗,錯誤訊息'+resp.data);
    }
  })
};

// 通過
const passed= async () => {
  tbtca62Vo.borrowApplyNo = tbtca61Vo.borrowApplyNo;
  console.log('tbtca62Vo.borrowApplyNo',tbtca62Vo.borrowApplyNo);
  console.log('tbtca62Vo.reviewComment',tbtca62Vo.reviewComment);
  const apiUrl='/tca/expenseborrow/passed'
  await $api(apiUrl, {
    method: 'POST',
    body: tbtca62Vo
  }).then((resp) => {
    if (resp.statusCode == 200) {
      popSwal('success','通過送出成功');
      query(tbtca61Vo.borrowApplyNo,false);
    } else  {
      popSwal('error','通過送出失敗,錯誤訊息'+resp.data);
    }
  })
};

// 駁回
const reject= async () => {
  tbtca62Vo.borrowApplyNo = tbtca61Vo.borrowApplyNo;
  const apiUrl='/tca/expenseborrow/reject'
  await $api(apiUrl, {
    method: 'POST',
    body: tbtca62Vo
  }).then((resp) => {
    if (resp.statusCode == 200) {
      popSwal('success','駁回送出成功');
      query(tbtca61Vo.borrowApplyNo,false);
    } else  {
      popSwal('error','駁回送出失敗,錯誤訊息'+resp.data);
    }
  })
};

// 取得可執行動作API
const getFormActions = async (formId) => {
  let apiUrl = '/form/getFormActions/' + formId;
  await $api(apiUrl, {
    method: 'GET',
  }).then((resp) => {
    if (resp && resp.actions) {
      Object.assign(viewParams.actionBtn, resp.actions.formActions);
    } else {
      console.error("Invalid response structure", resp);
    }
  }).catch((error) => {
    console.error("API request failed", error);
  });
};

</script>

<style scoped>
</style>
